export const baseStrapiGetLocalizedData = (entry: object) => {
  return entry?.attributes?.localizations?.data?.find((localization) => {
    return localization?.attributes?.locale === baseI18nGetActiveIso()
  }) || entry
}
